<template>
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4">
        <div class="bg-white rounded-lg pt-12 pb-8 px-6 md:pt-24 md:pb-12 md:px-12 relative text-center w-full max-w-2xl space-y-4">
            <i class="fa-light fa-circle-check text-emerald-500 text-7xl"></i>
            <div class="space-y-4 py-8">
                <h2 class="text-xl font-bold text-center">動画の登録が完了しました！</h2>
                <p class="text-center text-sm">文字起こしが開始されました。<br>閉じるを押して、文字起こし完了までしばらくお待ちください。</p>
            </div>
            <div class="text-center">
                <button @click="emit('close-modal')" class="btn-secondary">
                    閉じる
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue'

const emit = defineEmits(['close-modal']);

</script>